import 'aos/dist/aos.css';
import 'App.css';
import 'styles/modern-zu.css';
import 'styles/modern-credex.css';

import { AuthRepository } from 'infraestructure/repositories';
import { login, logout } from 'infraestructure/store/actions/auth';
import LoadingComponent from 'presentation/components/LoadingComponent';
import AuthConext from 'presentation/Context/Auth';
import { NavbarLayout } from 'presentation/layouts';
import React, { ReactElement } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import ReactPixel from 'react-facebook-pixel';
import { FloatingWhatsApp } from 'react-floating-whatsapp';
import ReactGA from 'react-ga';
import { HelmetProvider } from 'react-helmet-async';
import { AngleUpIcon } from 'react-line-awesome';
import { connect } from 'react-redux';
import ScrollToTop from 'react-scroll-to-top';

import RouterComponent from './presentation/components/RouterComponent';
import ScrollTop from './presentation/components/scrollTop';
import AlertLayout from './presentation/layouts/AlterLayout';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useBrand } from 'core/contexts/BrandContext';

const GAId = process.env.REACT_APP_GOOGLE_ANALYTICS_ID || '';
const FacebookPixelId = process.env.REACT_APP_FACEBOOK_PIXEL_ID || '';
const advancedMatching = {
  em: '',
  fn: '',
  ln: '',
  ct: '',
  country: '',
  db: '',
  ge: '',
  ph: '',
  st: '',
  zp: '',
};
const FPOptions = {
  autoConfig: true,
  debug: false,
};

if (FacebookPixelId && FacebookPixelId !== 'null' && FacebookPixelId !== 'undefined') {
  ReactPixel.init(FacebookPixelId, advancedMatching, FPOptions);
  ReactPixel.pageView();
}

if (GAId && GAId !== 'null' && GAId !== 'undefined') {
  ReactGA.initialize(GAId);
  ReactGA.pageview(window.location.pathname + window.location.search);
}

export interface AppProps {
  isLogged: boolean;
  login(): void;
  logout(): void;
  authLoading: boolean;
}

function App(props: AppProps): ReactElement {
  const brand = useBrand();
  const [isWhatsAppOpen, setIsWhatsAppOpen] = React.useState(false);
  const [queryClient] = React.useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5, 
        retry: 2,
      },
    },
  }));
  // (keep the rest of your component logic)
  const handleLoginChange = (isLogged: boolean) => {
    if (isLogged) {
      props.login();
    } else {
      props.logout();
    }
  };
  const repository = new AuthRepository();
  const context = { isLogged: props.isLogged, setIsLogged: handleLoginChange };

  React.useEffect(() => {
    const token = repository.loadToken();
    
    if (token !== null) {
      props.login();
    } else {
      props.logout();
    }
    const favicon = document.querySelector('#favicon');
    favicon?.setAttribute('href', process.env.REACT_APP_FAVICON || '');

    const descriptionSite = document.querySelector('meta[name="description"]');
    descriptionSite?.setAttribute(
      'content',
      process.env.REACT_APP_DESCRIPTION_SITE || ''
    );

    const keywordsSite = document.querySelector('meta[name="keywords"]');
    keywordsSite?.setAttribute('content', process.env.REACT_APP_KEYWORD || '');

    const copyrightSite = document.querySelector('meta[name="copyright"]');
    copyrightSite?.setAttribute(
      'content',
      process.env.REACT_APP_COPYRIGHT_SITE || ''
    );

    const ogTitleFacebook = document.querySelector('meta[name="og:title"]');
    ogTitleFacebook?.setAttribute(
      'content',
      process.env.REACT_APP_OG_TITLE || ''
    );

    const ogDescriptionFacebook = document.querySelector(
      'meta[name="og:description"]'
    );
    ogDescriptionFacebook?.setAttribute(
      'content',
      process.env.REACT_APP_DESCRIPTION_SITE || ''
    );

    const ogTitleTwitter = document.querySelector('meta[name="twitter:title"]');
    ogTitleTwitter?.setAttribute(
      'content',
      process.env.REACT_APP_OG_TITLE || ''
    );

    const ogDescriptionTwitter = document.querySelector(
      'meta[name="twitter:description"]'
    );
    ogDescriptionTwitter?.setAttribute(
      'content',
      process.env.REACT_APP_DESCRIPTION_SITE || ''
    );

    const ogUrl = document.querySelector('meta[name="og:url"]');
    ogUrl?.setAttribute('content', process.env.REACT_APP_WEB_URL || '');
  }, []);

  if (props.authLoading) { // props.isLogged &&
    return <LoadingComponent textLoading="Cargando sitio web..." />;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <AuthConext.Provider value={context}>
        <HelmetProvider>
          <div className={`App theme-${brand.id}`}>
            <NavbarLayout>
              <>
                <AlertLayout />
                <React.Suspense
                  fallback={
                    <Container className="spinner-show">
                      <Row>
                        <Col xs={12}>
                          <LoadingComponent textLoading="Cargando contenido del sitio..." />
                        </Col>
                      </Row>
                    </Container>
                  }
                >
                  <FloatingWhatsApp
                    phoneNumber={brand.contact.whatsappNumber}
                    accountName={brand.name}
                    statusMessage="En línea"
                    chatMessage={`Envíanos tu consulta \nPronto un asesor se comunicará contigo`}
                    placeholder="Escribe tu mensaje"
                    allowEsc
                    allowClickAway
                    avatar={brand.contact.whatsappAvatar}
                    onClick={() => setIsWhatsAppOpen(true)}
                    onClose={() => setIsWhatsAppOpen(false)}
                  />
                  <ScrollTop />
                  <ScrollToTop
                    smooth
                    component={<AngleUpIcon />}
                    color="white"
                    className={`scroll-to-top ${isWhatsAppOpen ? 'scroll-to-top--hidden' : ''}`}
                  />
                  <RouterComponent {...props} />
                </React.Suspense>
              </>
            </NavbarLayout>
          </div>
        </HelmetProvider>
      </AuthConext.Provider>
    </QueryClientProvider>
  );
}

const mapStateToProps = (state) => ({
  isLogged: state.auth.isLogged,
  authLoading: state.auth.authLoading,
});

const mapDispatchToProps = (dispatch) => {
  return {
    login: () => dispatch(login()),
    logout: () => dispatch(logout()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(App);
